
import Vue from 'vue'

export default Vue.extend({
  name: 'ChefBookExperienceAddress',
  props: {
    address: {
      type: Object,
      required: true
    }
  },
})
